<template>
  <div>
    <div>
      <Loading
        type="line"
        :center="false"
        v-show="loading"
      />
      <b-row>
        <b-col sm="12">
          <TableTotalRecords :totalRecords="content.totalRecords" />
        </b-col>
      </b-row>
    </div>
    <div class="table-items-nfse">
      <table class="table table-responsive-xs">
        <thead>
          <tr>
            <th>
              <span class="title-header">NUMERO</span>
            </th>
            <th class="text-center">
              <span class="title-header">EMISSAO</span>
            </th>
            <th>
              <span class="title-header">CLIENTE</span>
            </th>
            <th class="text-center">
              <span class="title-header">STATUS</span>
            </th>
            <th class="text-center">
              <span class="title-header">VALOR</span>
            </th>
            <th></th>
          </tr>
        </thead>

        <NfseListItem
          v-for="item in content.data"
          :key="item.id || item.numero || item.registeredDate"
          :item="item"
        />

        <tbody v-show="content.totalRecords == 0">
          <tr>
            <td colspan="8">
              <span class="title">Nenhum registro encontrado!</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ButtonSub from "@nixweb/nixloc-ui/src/component/forms/ButtonSub.vue";
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import TableTotalRecords from "@nixweb/nixloc-ui/src/component/shared/TableTotalRecords.vue";

import NfseListItem from "./NfseListItem.vue";

import { mapActions, mapState } from "vuex";

export default {
  name: "ItemsLista",
  components: {
    Loading,
    ScrollBar,
    TableTotalRecords,
    ButtonSub,
    NfseListItem,
  },
  props: {
    rent: Object,
  },
  data() {
    return {
      urlGetApi: "/api/v1/tax-document/nfse-shared/get-all",
      data: [],
      loading: true,
      content: {
        data: [],
        totalRecords: 0,
      },
    };
  },
  mounted() {
    this.getAll();
  },
  computed: {
    ...mapState("generic", ["event"]),
  },
  methods: {
    ...mapActions("generic", ["getApi"]),
    getAll() {
      this.loading = true;
      const params = {
        url: this.urlGetApi,
        obj: {
          locacaoId: this.rent.id,
        },
      };

      this.getApi(params)
        .then((response) => {
          const content = response?.content;
          const data = Array.isArray(content) ? content : content?.data || [];

          this.content.data = data.map((item) => ({
            id: item.id || item.Id || "",
            cliente: item.cliente || item.Cliente || "",
            numero: item.numero || item.Numero || "",
            origem: item.origem || item.Origem || "",
            status: item.status || item.Status || 0,
            statusNome: item.statusNome || item.StatusNome || "",
            registeredDate: item.registeredDate || item.RegisteredDate || "",
            valorNota: item.valorNota || item.ValorNota || 0,
            locacaoId: item.locacaoId || item.LocacaoId || "",
            urlPdf: item.urlPdf || item.UrlPdf || "",
            urlXml: item.urlXml || item.UrlXml || "",
          }));

          this.content.totalRecords =
            content?.totalRecords || this.content.data.length;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "canceledNfse" || event.name == "refreshNfse") {
          this.getAll();
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.table th {
  height: 10px !important;
  padding-left: 5px !important;
  padding-top: 7px !important;
  padding-bottom: 5px !important;
  padding-right: 5px !important;
  padding-left: 10px !important;
  border-bottom: 0 !important;
}

.title-header {
  font-size: 14px;
  color: #757d8c;
  font-weight: 400;
  text-transform: uppercase;
}

.table-items-nfse {
  min-height: 300px;
}
</style>
